export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-page-export-doc-2cce379c1e07df5860eb4be6f346bf72.svg";